module.exports = __webpack_public_path__ + "img/cooperate_28.9ec0104e.svg";